import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatNumberWithCommas(value: string | number | null | undefined): string {
  // Handle non-string values
  if (value === null || value === undefined) {
    return '';
  }
  
  const stringValue = String(value);
  
  // Regex to find numbers in the string
  return stringValue.replace(/\b(\d+)\b/g, (match) => {
    const num = match;
    // If number has ≤3 digits, return unchanged
    if (num.length <= 3) {
      return num;
    }
    // Add commas every 3 digits from the right
    return num.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  });
}
